/* eslint-disable import/prefer-default-export */
import {
  GET_TWILIO_TOKEN_FAILURE,
  GET_TWILIO_TOKEN_REQUEST,
  GET_TWILIO_TOKEN_SUCCESS,
  VERIFY_PHONE_NUMBER_FAILURE,
  VERIFY_PHONE_NUMBER_REQUEST,
  VERIFY_PHONE_NUMBER_SUCCESS,
} from '../../../actionConstants';

import apiClient from '../../../apiClient';

export const getTwilioToken = (dispatch) =>
  dispatch({
    type: GET_TWILIO_TOKEN_REQUEST,
    payload: apiClient.twilio.getToken().then(
      (res) => {
        dispatch({
          type: GET_TWILIO_TOKEN_SUCCESS,
          res,
        });
        return res;
      },
      (err) => {
        dispatch({
          type: GET_TWILIO_TOKEN_FAILURE,
          err,
        });
      },
    ),
  });

export const verifyPhoneNumber = (dispatch, buildingId) =>
  dispatch({
    type: VERIFY_PHONE_NUMBER_REQUEST,
    payload: apiClient.twilio
      .verifyPhoneNumber(buildingId, { callDelay: 30 })
      .then(
        (res) => {
          dispatch({
            type: VERIFY_PHONE_NUMBER_SUCCESS,
            res,
          });
          return res?.data?.code;
        },
        (err) =>
          dispatch({
            type: VERIFY_PHONE_NUMBER_FAILURE,
            err,
          }),
      ),
  });
